import _ from 'underscore';
import * as commonSharedTrackingHelper from '../../../home24-shared/tracking/common/helper';
import BaseTrackingView from '../../core/baseTrackingView';
import * as commonTrackingHelper from '../../tracking/common/helper';
import * as registry from '../../../home24/core/registry';
import * as cartHelper from '../../tracking/cart/helper';

export default BaseTrackingView.extend({

    events: {
        'click #js-to-checkout-button': 'toCheckoutClick',
        'click #js-to-cart-button': 'toCartClick',
        'click #js-close-cart-overlay-button': 'closeCartOverlayClick'
    },

    closeCartOverlayClick: function () {
        /* istanbul ignore else  */
        if (commonTrackingHelper.isGTMLoaded()) {
            window.dataLayer.push({
                clicked_button: 'go to shop',
                event: 'addToCartOverlay_clicked'
            });
        }
    },

    toCartClick: function (event) {

        /* istanbul ignore else  */
        if (commonTrackingHelper.isGTMLoaded()) {
            commonSharedTrackingHelper.addToDataLayerForLinks(event, {
                clicked_button: 'go to cart',
                event: 'addToCartOverlay_clicked'
            });

        }

    },

    attachExtraTracking: function () {
        window.dataLayer.push({
            clicked_button: 'go to checkout',
            event: 'addToCartOverlay_clicked'
        });
    },

    toCheckoutClick: function (event) {
        /* istanbul ignore else  */
        if (commonTrackingHelper.isGTMLoaded()) {
            var aProducts = this.getTrackingData();
            var aProductsArr = [];
            var cartValue = 0;

            if (_.isArray(aProducts)) {
                aProductsArr = aProducts;

                try {
                    _.each(aProductsArr, function (prod) {
                        cartValue += parseFloat(prod.price) * prod.quantity;
                    });
                } catch (e) {
                }
            } else if (aProducts && _.isArray(aProducts.cartContent)) {
                aProductsArr = aProducts.cartContent;
                cartValue = aProducts.cartValue;
            }

            if (aProductsArr && aProductsArr.length > 0) {
                this.attachExtraTracking();

                commonSharedTrackingHelper.addToDataLayerForLinks(event, {
                    event: 'checkout',
                    ecommerce: {
                        checkout: {
                            actionField: { step: 1 },
                            products: aProductsArr
                        },
                        cartValue: cartValue,
                        currencyCode: registry.get('currencyCode')
                    }
                });
            }

        }
    },

    getTrackingData: function () {
        if (!this.trackingData) {
            this.trackingData = cartHelper.getOverlayData();
        }

        return this.trackingData;
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/cart/CartOverlayEvents.js
 **/